import React, { useEffect, useState } from "react";
import {
  Button,
  Breadcrumb,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Form,
  Row,
  Stack,
  Modal,
  FormSelect,
  InputGroup,
} from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
// import "react-bootstrap-typeahead/css/Typeahead.css";
import PubSub from "pubsub-js";
import moment from "moment";
import { ROUTES } from "../../constants/webRouting";
import fuziElevatorsApi from "../../api/fuziElevatorsApi";
import CityState from "../../constants/CityState.json";
import * as constants from "../../constants/CONSTANT";
import authApi from "../../api/authApi";
import { regExPattern } from "../../utils/regExPattern";
import {
  formatDate,
  formatDateForCreatedDate,
  getUserDetails,
} from "../../utils/helper";
// import jwt_decode from "jwt-decode";
import { validationMessages } from "../../utils/messages";
import { handleUppercaseChange } from "../common/UpperCaseMethod";
import PERMISSIONS from "../../constants/permissions";
//Imran Khan Added segmentOptions on 16/01/2026
// const segmentOptions = [
//   "Residential",
//   "Hospital",
//   "Hotel",
//   "School",
//   "College",
//   "Commercial",
//   "Office",
//   "Villa",
//   "Retail",
//   "Infra",
//   "Temple",
// ].map((item) => ({
//   label: item,
//   value: item,
// }));
//End here Imran Khan


const LeadEdit = (props) => {
  const userInfo = getUserDetails();
  const location = useLocation();
  const navigate = useNavigate();
  const [showContactModel, setContactModel] = useState(false);//Added by shahir hussain case 1002 - 11-12-2025
  const [contactRef, setContactRecord] = useState({});//Added by shahir hussain case 1002 - 11-12-2025
  // console.log("userInfo", userInfo);
  const initialValues = {
    owner_ids: [{ value: userInfo?.id, label: userInfo?.username }],
    country: "India",
    is_gst: "Yes",
    city: "Jaipur",
    is_lost_date: null,
  };

  // Define initial errors i.e. required field and their message.
  const initialErrors = {
    lead_name: { message: validationMessages.leadName.required },
    leadtype: { message: validationMessages.leadType.required },
    phone: { message: validationMessages.phone.required },
    lead_status: { message: validationMessages.leadStatus.required },
    owner_ids: { message: validationMessages.ownerIds.required },
    customer_type: { message: validationMessages.customerType.required },
    city: { message: validationMessages.city.required },
    segment: { message: validationMessages.segment.required },
    area: { message: validationMessages.area.required },
  };

  // lead state
  const [lead, setLead] = useState(
    location.state ? location.state : initialValues,
  );
  //errors state
  const [errors, setErrors] = useState(!location.state ? initialErrors : {});
  useEffect(() => {
    console.log("errors", errors);
  }, [errors]);

  const [validated, setValidated] = useState(false);
  const [assignUsers, setAssignUsers] = useState([]);
  const [companyMakeOption, setCompanyMakeOption] = useState([]);  //Imran Khan Added on 06-02-2026
  //Imran Khan Added  on 20/01/2026
  const [lostLeadData, setLostLeadData] = useState({
    // is_lost_date: location?.state?.is_lost_date || new Date(),
    is_lost_date: new Date(),
    lead_lost_remark: "",
    lost_by_reason: "",
  });

  const handleLostLeadChange = (e) => {
    const { name, value } = e.target;

    setLostLeadData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleLostLeadSave = () => {
    setLead((prev) => ({
      ...prev,
      is_lost_date: new Date(),
      lead_lost_remark: lostLeadData.lead_lost_remark,
      lost_by_reason: lostLeadData.lost_by_reason,
    }));

    handleClose();
  };

  // Handle City & state values
  const [states, setStates] = useState([
    ...new Set(CityState.map((item) => item.state)),
  ]);
  const [statusArray, setStatusArray] = useState(constants.LEAD_STATUS_VALUES);
  const [segmentOptions, setSegmentOptions] = useState(constants?.SegmentOptions);//Added by shahir hussain for segment type field 02-02-2025


  const [products, setProducts] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [refContact, setRefContact] = useState([]);
  // const [offers, setOffers] = useState([]);
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setLostLeadData({
      //is_lost_date: null,
      lead_lost_remark: "",
      lost_by_reason: "",
    });
    setShow(false);
  };
  const handleShow = () => setShow(true);

  //Imran Khan 14-01-2026 Permission Code Update Here
  async function init() {
    if (!Array.isArray(userInfo?.permissions)) return;

    // helper
    const hasPermission = (permission) =>
      userInfo.permissions.some((p) => p.name === permission);

    // USERS
    if (
      hasPermission(PERMISSIONS.VIEW_ALL) ||
      hasPermission(PERMISSIONS.VIEW_USER)
    ) {
      const resultedUsers = await fuziElevatorsApi.fetchUsers();
      Array.isArray(resultedUsers) && setAssignUsers(resultedUsers);
    }

    //Product
    if (
      hasPermission(PERMISSIONS.VIEW_ALL) ||
      hasPermission(PERMISSIONS.VIEW_PRODUCT)
    ) {
      const fetchedProducts = await fuziElevatorsApi.fetchProducts();

      if (Array.isArray(fetchedProducts)) {
        setProducts(
          fetchedProducts?.map((p) => ({
            value: p?.id,
            label: p?.product_name || "",
          })),
        );
      }
    }

    // CONTACTS
    if (
      hasPermission(PERMISSIONS.VIEW_ALL) ||
      hasPermission(PERMISSIONS.VIEW_CONTACT)
    ) {
      const fetchedRefrealContact =
        await fuziElevatorsApi.fetchContactsForEnquiry();
      Array.isArray(fetchedRefrealContact) &&
        setRefContact(
          fetchedRefrealContact.map((c) => ({
            id: c.id,
            contact_name: `${c.firstname || ""} ${c.lastname || ""}`,
          })),
        );
    }
    //Make View
    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS.VIEW_MAKE].some((permission) =>
        userInfo?.permissions?.map((p) => p?.name).includes(permission),
      )
    ) {
      const resultedAccounts = await fuziElevatorsApi?.fetchAccounts();
      Array.isArray(resultedAccounts) && setAccounts(resultedAccounts);
    }

    if (
      [PERMISSIONS.VIEW_ALL, PERMISSIONS?.VIEW_MAKE].some((permission) => {
        return userInfo?.permissions?.map((p) => p.name).includes(permission);
      })
    ) {
      const resultedMakes = await fuziElevatorsApi.fetchAccountsByType();

      if (resultedMakes) {
        setCompanyMakeOption(resultedMakes?.company_make);
      }
    }
    // Account
    if (
      hasPermission(PERMISSIONS.VIEW_ALL) ||
      hasPermission(PERMISSIONS.VIEW_MAKE)
    ) {
      const resultedAccounts = await fuziElevatorsApi.fetchAccounts();
      Array.isArray(resultedAccounts) && setAccounts(resultedAccounts);
    }
  }
  useEffect(() => {
    init();
  }, []);
  // End Here Imran Khan 14-01-2026 Permission Code Update Here

  useEffect(() => {
    // New Lead create case
    if (!lead?.qty) {
      setLead((prev) => ({
        ...prev,
        qty: 1,
      }));
    }
  }, []);

  //Imran Khan Changes segment on 16/01/2026
  const handleChange = (e) => {
    // const { name } = e.target;
    const { name, value, options } = e?.target;
    console.log("name == ", name);
    //let { value } = e.target;
    if (name === "segment") {
      const values = Array.isArray(value)
        ? value?.map((item) => item?.value)
        : [];

      const segmentString = values.join(",");

      setLead((prev) => ({
        ...prev,
        segment: segmentString,
      }));

      // validation
      if (values?.length === 0) {
        setErrors((prev) => ({
          ...prev,
          segment: { message: validationMessages.segment.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev.segment;
          return { ...prev };
        });
      }

      setValidated(true);
      return;
    }

    if (name == "lead_name") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.leadName.required },
        }));
      } else if (e?.target?.pattern && !RegExp(e.target.pattern).test(value)) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.leadName.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "leadtype") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.leadType.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "lead_status") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.leadStatus.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "email") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.email.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    //Imran Khan Added on 13-01-2026 for Form Data Handling in Lead Edit Component
    else if (name === "qty") {
      if (!value || Number(value) < 1) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: "Quantity must be at least 1" },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "phone") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.phone.required },
        }));
      } else if (e?.target?.pattern && !RegExp(e.target.pattern).test(value)) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.phone.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "whatsapp_no") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.whatsappNumber.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "owner_ids") {
      if (!value?.length) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.ownerIds.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "customer_type") {
      value != "Corporate" && setLead((pre) => ({ ...pre, company_name: "" }));
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.customerType.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "company_name") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.name.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "is_gst") {
      console.log("is_gst == ", name);
      value != "Yes" && setLead((pre) => ({ ...pre, gst_no: "" }));
    } else if (name == "customer_primary_phone") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.phone.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "customer_secondary_phone") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.phone.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "city") {
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.city.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    } else if (name == "area") {
      //Added by shahir hussain 23-12-2025
      if (value == "") {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.area.required },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }
    // else if (name == "segment") { //{/* Added By Farhan Khan on 17-Dec-2025 As Per Client Needs New Field Segment as Required in AMC Ticket 1009 */}
    //   if (value == "") {
    //     setErrors((prev) => ({
    //       ...prev,
    //       [name]: { message: validationMessages.segment.required },
    //     }));
    //   } else {
    //     setErrors((prev) => {
    //       delete prev[name];
    //       return { ...prev };
    //     });
    //   }
    // }//{/* End Here By Farhan Khan on 17-Dec-2025 As Per Client Needs New Field Segment as Required in AMC Ticket 1009 */}
    else if (name == "pincode") {
      if (
        value != "" &&
        e?.target?.pattern &&
        !RegExp(e.target.pattern).test(value)
      ) {
        setErrors((prev) => ({
          ...prev,
          [name]: { message: validationMessages.pinCode.invalid },
        }));
      } else {
        setErrors((prev) => {
          delete prev[name];
          return { ...prev };
        });
      }
    }

    // Imran khan Update Enquiry Lost Modal Code Here 07-01-2026
    if (name === "lead_status" && value === "Enquiry Lost") {
      setLostLeadData((prev) => ({
        ...prev,
        is_lost_date: new Date(),
      }));
      handleShow();
    }
    setValidated(true);
    setLead((prev) => ({ ...prev, [name]: value }));
  };
  //end Imran khan Update Enquiry Lost Modal Code Here 07-01-2026

  // field validators
  const checkRequiredFields = () => {
    let isError = false;
    if (lead?.salutation) {
    }

    if (lead?.lead_name) {
      if (lead?.lead_name == "") {
        setErrors((prev) => ({
          ...prev,
          lead_name: { message: validationMessages.leadName.required },
        }));
        isError = true;
      } else if (
        regExPattern?.name &&
        !RegExp(regExPattern.name).test(lead.lead_name)
      ) {
        setErrors((prev) => ({
          ...prev,
          lead_name: { message: validationMessages.leadName.invalid },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["lead_name"];
          return { ...prev };
        });
      }
    }

    if (lead?.leadtype) {
      if (lead?.leadtype == "") {
        setErrors((prev) => ({
          ...prev,
          leadtype: { message: validationMessages.leadType.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["leadtype"];
          return { ...prev };
        });
      }
    }

    if (lead?.lead_status) {
      if (lead?.lead_status == "") {
        setErrors((prev) => ({
          ...prev,
          lead_status: { message: validationMessages.leadStatus.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["lead_status"];
          return { ...prev };
        });
      }
    }

    if (lead?.phone) {
      if (lead?.phone == "") {
        setErrors((prev) => ({
          ...prev,
          phone: { message: validationMessages.phone.required },
        }));
        isError = true;
      } else if (
        regExPattern?.phone &&
        !RegExp(regExPattern.phone).test(lead.phone)
      ) {
        setErrors((prev) => ({
          ...prev,
          phone: { message: validationMessages.phone.invalid },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["phone"];
          return { ...prev };
        });
      }
    }

    if (lead?.email) {
      if (
        lead?.email != "" &&
        regExPattern?.email &&
        !RegExp(regExPattern.email).test(lead.email)
      ) {
        setErrors((prev) => ({
          ...prev,
          email: { message: validationMessages.email.invalid },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["email"];
          return { ...prev };
        });
      }
    }

    if (lead?.whatsapp_no) {
      if (
        lead?.whatsapp_no != "" &&
        regExPattern?.whatsapp_no &&
        !RegExp(regExPattern.whatsapp_no).test(lead.whatsapp_no)
      ) {
        setErrors((prev) => ({
          ...prev,
          whatsapp_no: { message: validationMessages.whatsappNumber.invalid },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["whatsapp_no"];
          return { ...prev };
        });
      }
    }

    if (lead?.owner_ids) {
      if (!lead?.owner_ids?.length) {
        setErrors((prev) => ({
          ...prev,
          owner_ids: { message: validationMessages.ownerIds.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["owner_ids"];
          return { ...prev };
        });
      }
    }

    if (lead?.customer_type) {
      if (lead?.customer_type == "") {
        setErrors((prev) => ({
          ...prev,
          customer_type: { message: validationMessages.customerType.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["customer_type"];
          return { ...prev };
        });
      }
    }

    if (lead?.company_name) {
      if (
        lead?.company_name != "" &&
        regExPattern?.name &&
        !RegExp(regExPattern.name).test(lead.company_name)
      ) {
        setErrors((prev) => ({
          ...prev,
          company_name: { message: validationMessages.name.invalid },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["company_name"];
          return { ...prev };
        });
      }
    }

    if (lead?.customer_primary_phone) {
      if (
        lead?.customer_primary_phone != "" &&
        regExPattern?.phone &&
        !RegExp(regExPattern.phone).test(lead.customer_primary_phone)
      ) {
        setErrors((prev) => ({
          ...prev,
          customer_primary_phone: { message: validationMessages.phone.invalid },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["customer_primary_phone"];
          return { ...prev };
        });
      }
    }

    if (lead?.customer_secondary_phone) {
      if (
        lead?.customer_secondary_phone != "" &&
        regExPattern?.phone &&
        !RegExp(regExPattern.phone).test(lead.customer_secondary_phone)
      ) {
        setErrors((prev) => ({
          ...prev,
          customer_secondary_phone: {
            message: validationMessages.phone.invalid,
          },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["customer_secondary_phone"];
          return { ...prev };
        });
      }
    }

    if (lead?.city) {
      if (lead?.city == "") {
        setErrors((prev) => ({
          ...prev,
          city: { message: validationMessages.city.required },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["city"];
          return { ...prev };
        });
      }
    }

    if (lead?.pincode) {
      if (
        lead?.pincode != "" &&
        regExPattern?.pinCode &&
        !RegExp(regExPattern.pinCode).test(lead.pincode)
      ) {
        setErrors((prev) => ({
          ...prev,
          pincode: { message: validationMessages.pinCode.invalid },
        }));
        isError = true;
      } else {
        setErrors((prev) => {
          delete prev["pincode"];
          return { ...prev };
        });
      }
    }

    if (!lead?.lead_name) {
      setErrors((prev) => ({
        ...prev,
        lead_name: { message: validationMessages.leadName.required },
      }));
      isError = true;
    }
    if (!lead?.leadtype) {
      setErrors((prev) => ({
        ...prev,
        leadtype: { message: validationMessages.leadType.required },
      }));
      isError = true;
    }
    if (!lead?.lead_status) {
      setErrors((prev) => ({
        ...prev,
        lead_status: { message: validationMessages.leadStatus.required },
      }));
      isError = true;
    }
    if (!lead?.phone) {
      setErrors((prev) => ({
        ...prev,
        phone: { message: validationMessages.phone.required },
      }));
      isError = true;
    }
    if (!lead?.owner_ids?.length) {
      setErrors((prev) => ({
        ...prev,
        owner_ids: { message: validationMessages.ownerIds.required },
      }));
      isError = true;
    }
    if (!lead?.customer_type) {
      setErrors((prev) => ({
        ...prev,
        customer_type: { message: validationMessages.customerType.required },
      }));
      isError = true;
    }
    if (!lead?.city) {
      setErrors((prev) => ({
        ...prev,
        city: { message: validationMessages.city.required },
      }));
      isError = true;
    }

    return isError;
  };

  // onSubmit handler
  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("lead", lead);
    console.log("errors", errors);
    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }
    console.log("lead", lead);
    console.log("errors", errors);
    if (Object?.keys(errors)?.length != 0) {
      setValidated(true);
      return;
    }
    // copy the obj to send as payload
    const record = { ...lead };

    //Delete Extra Fields from Lead JSON.

    delete record.owner_name;
    delete record.contact_name;
    delete record.product_name;

    //End Here Delete Extra Fields from Lead JSON.

    if (record?.date_of_birth) {
      record.date_of_birth = moment(record.date_of_birth).format(
        "DD MMM, yyyy",
      );
    }
    if (record?.anniversary_date) {
      record.anniversary_date = moment(record.anniversary_date).format(
        "DD MMM, yyyy",
      );
    }
    if (record?.is_lost_date) {
      record.is_lost_date = moment(record.is_lost_date).format("DD MMM, yyyy");
    }

    // handle numeric fields
    record.qty = record?.qty == "" ? 0 : record.qty;

    // handle date fields
    record.date_of_birth =
      record?.date_of_birth == "" ? null : record.date_of_birth;
    record.anniversary_date =
      record?.anniversary_date == "" ? null : record.anniversary_date;
    record.is_lost_date =
      record?.is_lost_date == "" ? null : record.is_lost_date;

    record.customer_site_visit_date =
      record?.customer_site_visit_date == ""
        ? null
        : record.customer_site_visit_date;
    delete record.owner_name;

    // handel account_id make
    record.account_id = record.accounts
      ?.filter((item) => item.value)
      ?.map((item) => item.value);
    delete record.accounts;

    // handel owner_ids
    record.owner_ids = record.owner_ids
      ?.filter((item) => item.value)
      ?.map((item) => item.value);
    // //========= Logic to perform Create or Edit ======
    if (record.id) {
      // console.log("Updated");
      const result = await fuziElevatorsApi.saveLead(record);
      console.log("first", result);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Update",
          message: `${result?.message ? result?.message : "Record updated successfully"
            }`,
        });
        // navigate(`/leads/${record.id}`, { state: record });
        navigate(`${ROUTES.LEAD.LIST}/${record.id}`, { state: record });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Error found",
          message: `${result?.errors ? result?.errors : "Some error found"}`,
        });
      }
    } else {
      // console.log("Created");
      const result = await fuziElevatorsApi.createLead(record);
      console.log("first", result);
      if (result?.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record created",
          message: "Record created successfully",
        });
        // console.log("result", result);
        navigate(`${ROUTES.LEAD.LIST}/${result?.data?.id}`, {
          state: result?.data,
        });
      } else {
        PubSub.publish("RECORD_ERROR_TOAST", {
          title: "Error found",
          message: `${result?.errors ? result?.errors : "Some error found"}`,
        });
      }
    }
  };

  //
  const handleCancel = () => {
    if (lead.id) {
      navigate(`${ROUTES.LEAD.LIST}/${lead.id}`, { state: lead });
    } else {
      navigate(ROUTES.LEAD.LIST);
    }
  };

  // const handleAssignedUserChange = (e) => {
  //   handleChange({ target: { name: "owner_id", value: e.value } });
  //   handleChange({ target: { name: "owner_name", value: e.label } });
  //   // const delegated_users = assignUsers?.filter((item) => item.managerid == e.value)?.map((item) => ({ value: item.id, label: item.username }));
  //   // if (lead.id) {
  //   //   if (lead.delegated_users && Array.isArray(lead.delegated_users)) {
  //   //     setLead((prev) => ({ ...prev, delegated_users: [...delegated_users, ...lead.delegated_users] }));
  //   //   } else {
  //   //     setLead((prev) => ({ ...prev, delegated_users: [...delegated_users] }));
  //   //   }
  //   // } else {
  //   // setLead((prev) => ({ ...prev, delegated_users: [...delegated_users] }));
  //   // }
  // };

  //Added by shahir hussain 11-12-2025 AMC Ticket Number 1002
  const handleContactModel = () => {
    setContactModel(true);
  };

  //Added by shahir hussain 11-12-2025 AMC Ticket Number 1002
  const handleContactModelClose = () => {
    setContactRecord({});
    setContactModel(false);
  };

  //Added by shahir hussain 11-12-2025 AMC Ticket Number 1002
  const handleChangeContactPartner = (e) => {
    setContactRecord({ ...contactRef, [e.target.name]: e.target.value });
  };

  //Added by shahir hussain 11-12-2025 AMC Ticket Number 1002
  const handleSubmitContact = async (e) => {
    if (!contactRef || Object.keys(contactRef).length === 0) {
      return;
    } else if (
      !contactRef.firstname ||
      contactRef.firstname === "" ||
      !contactRef.lastname ||
      contactRef.lastname === "" ||
      !contactRef.phone ||
      contactRef.phone === ""
    ) {
      return PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Required",
        message: "Please fill all required fields",
      });
    }
    let result = {};
    contactRef.title = "Customer";
    result = await fuziElevatorsApi.createContact(contactRef);
    if (result?.success) {
      PubSub.publish("RECORD_SAVED_TOAST", {
        title: "Record created",
        message: "Record created successfully",
      });

      const fullName =
        `${contactRef?.firstname || ""} ${contactRef?.lastname || ""}`.trim();
      const newContact = {
        id: result?.id,
        contact_name: fullName,
      };
      setRefContact((prev) => [...prev, newContact]);

      setLead((prev) => ({
        ...prev,
        contact_id: result?.id,
        contact_name: fullName,
      }));
      // navigate(`${ROUTES.CONTACT.LIST}/${result.id}`, { state: result.data });
      setContactModel(false);
    } else {
      PubSub.publish("RECORD_ERROR_TOAST", {
        title: "Record Save Error",
        message: result?.errors,
      });
    }
  };

  return (
    <Container className="pb-5">
      {/* Imran khan Update Enquiry Lost Modal Code Here 07-01-2026 */}
      <>
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>REASON OF ENQUIRY LOST LEAD</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Col lg={12}>
              <Form.Group>
                <Form.Label>Lost Date</Form.Label>
                <Form.Control
                  disabled
                  value={formatDateForCreatedDate(lead?.is_lost_date)}
                />
              </Form.Group>
            </Col>
            <Col lg={12} className="mt-2">
              <Form.Group>
                <Form.Label>Enquiry Lost Reason</Form.Label>
                <Form.Control
                  type="text"
                  name="lead_lost_remark"
                  placeholder="Lead Lost Remark"
                  value={lostLeadData.lead_lost_remark}
                  onChange={handleLostLeadChange}
                />
              </Form.Group>
            </Col>
            <Col lg={12} className="mt-2">
              <Form.Group>
                <Form.Label>Lost By (Company)</Form.Label>
                <Form.Control
                  type="text"
                  name="lost_by_reason"
                  placeholder="Lost by Reason"
                  value={lostLeadData.lost_by_reason}
                  onChange={handleLostLeadChange}
                />
              </Form.Group>
            </Col>

            {/* I will not close if you click outside me. Do not even try to press
          escape key. */}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleLostLeadSave}>
              Save
            </Button>

            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            {/* <Button variant="primary">Understood</Button> */}
          </Modal.Footer>
        </Modal>
      </>
      {/* End Here Imran khan Update Enquiry Lost Modal Code Here 07-01-2026 */}
      <Row>
        <Col md={12} className="sticky-breadcrumb">
          <Breadcrumb>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.HOME)}>
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={() => navigate(ROUTES.LEAD.LIST)}>
              Leads
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col md={12}>
          <Form
            className=""
            onSubmit={handleSubmit}
            noValidate
            validated={validated}
          >
            <Card className="shadow">
              <CardHeader className="bg-custom text-white sticky-card-header">
                <Row className="w-100">
                  <Col lg={6} className="">
                    <div className="d-flex align-items-center h-100 gap-3">
                      {lead.id ? (
                        <h5 className="m-0">Edit Lead {lead.lead_name}</h5>
                      ) : (
                        <h5 className="m-0">Create Lead</h5>
                      )}
                    </div>
                  </Col>
                  <Col lg={6} className="">
                    <Stack direction="horizontal" className="float-end" gap={2}>
                      <Button
                        size="sm"
                        className="btn-save"
                        type="submit"
                      // onClick={handleSubmit}
                      >
                        Save
                      </Button>
                      <Button
                        size="sm"
                        className="btn-cancel"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                    </Stack>
                  </Col>
                </Row>
              </CardHeader>

              <CardBody className="">
                <Row lg={12} className="view-form ">
                  {/* <Col md={12} className="section-header">lead Information</Col> */}
                  <>
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicDate"
                        >
                          lead Date
                        </Form.Label>
                        <Form.Control
                          disabled
                          value={
                            lead?.id
                              ? moment(lead?.createddate).format("DD-MM-YYYY")
                              : moment().format("DD-MM-YYYY")
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicLastName"
                        >
                          Lead Name
                        </Form.Label>
                        <Form.Control
                          required
                          pattern={regExPattern.name}
                          type="text"
                          name="lead_name"
                          placeholder="Enter lead name"
                          value={lead?.lead_name || ""}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.lead_name?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicLead"
                        >
                          Lead Type
                        </Form.Label>
                        <Form.Select
                          required
                          placeholder="Select lead type"
                          aria-label="Select lead type"
                          name="leadtype"
                          value={lead?.leadtype || ""}
                          onChange={handleChange}
                        >
                          <option value="">---Select---</option>
                          {["New", "Modification", "AMC", "OneTime"].map(
                            (item, index) => (
                              <option value={item} key={index}>
                                {item}
                              </option>
                            ),
                          )}
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                          {errors?.leadtype?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label>Lead Status</Form.Label>
                        <Form.Select
                          required
                          name="lead_status"
                          value={lead?.lead_status || ""}
                          onChange={handleChange}
                        >
                          <option value="">--Select-Status--</option>
                          {statusArray.map((item, index) => (
                            <option value={item.label} key={index}>
                              {item.label}
                            </option>
                          ))}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.lead_status?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicEmail"
                        >
                          Email
                        </Form.Label>
                        <Form.Control
                          pattern={regExPattern.email}
                          type="email"
                          name="email"
                          placeholder="Enter email"
                          value={lead?.email || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.email?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicWhatsAppNumber"
                        >
                          Phone
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          name="phone"
                          placeholder="Enter phone number"
                          value={lead?.phone || ""}
                          onChange={handleChange}
                          maxLength={10}
                          pattern={regExPattern.phone}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.phone?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicWhatsAppNumber"
                        >
                          WhatsApp Number.
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="whatsapp_no"
                          placeholder="Enter whatsApp number"
                          value={lead?.whatsapp_no || ""}
                          onChange={handleChange}
                          maxLength={10}
                          pattern={regExPattern.phone}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.whatsapp_no?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicTelephone"
                        >
                          Telephone Number
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="teliphone"
                          placeholder="Enter telephone number"
                          value={lead?.teliphone || ""}
                          onChange={handleChange}
                        // maxLength={10}
                        // pattern={regExPattern.tel}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.teliphone?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formDateOfBirth"
                        >
                          Date of Birth
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="date_of_birth"
                          placeholder="Select date of birth"
                          value={
                            lead?.date_of_birth
                              ? formatDate(lead.date_of_birth)
                              : ""
                          }
                          onChange={handleChange}
                          max={moment(new Date()).format("YYYY-MM-DD")}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.date_of_birth?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formAnniversaryDate"
                        >
                          Anniversary Date
                        </Form.Label>
                        <Form.Control
                          type="date"
                          name="anniversary_date"
                          placeholder="Select anniversary date"
                          value={
                            lead?.anniversary_date
                              ? formatDate(lead.anniversary_date)
                              : ""
                          }
                          onChange={handleChange}
                          max={moment(new Date()).format("YYYY-MM-DD")}
                          onKeyDown={(e) => e.preventDefault()}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.anniversary_date?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicLeadSource"
                        >
                          lead Source
                        </Form.Label>
                        <Form.Select
                          placeholder="Select lead source"
                          aria-label="Select lead source"
                          name="leadsource"
                          value={lead?.leadsource || ""}
                          onChange={handleChange}
                        >
                          <option value="">---Select---</option>
                          {constants.sourceNames?.map((item, index) => (
                            <option value={item} key={index}>
                              {item}
                            </option>
                          ))}
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                          {errors?.leadsource?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* Added By Farhan Khan on 17-Dec-2025 As Per Client Needs in AMC Ticket 1009 */}
                    {/*<Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicSegment"
                          >
                            Segment Type
                          </Form.Label>
                           <Form.Select
                            required
                            placeholder="Select Segment Type"
                            aria-label="Select Segment Type"
                            name="segment"
                            value={lead?.segment || ""}
                            onChange={handleChange}
                          >
                            <option value="">---Select---</option>
                            {[
                              "Residential",
                              "Hospital",
                              "Hotel",
                              "School",
                              "College",
                              "Commercial",
                              "Office",
                              "Villa",
                              "Retail",
                              "Infra",
                              "Temple",
                            ].map((item, index) => (
                              <option value={item} key={index}>
                                {item}
                              </option>
                            ))}
                          </Form.Select>  
                        </Form.Group>
                      </Col>*/}
                    {/* End Here By Farhan Khan on 17-Dec-2025 As Per Client Needs in AMC Ticket 1009 */}

                    {/* Imran Khan Added by Segment Type on 16/01/2026 */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Segment Type
                        </Form.Label>

                        <Select
                          isMulti
                          placeholder="Select Segment Type"
                          options={segmentOptions}
                          value={
                            typeof lead?.segment === "string" && lead?.segment
                              ? segmentOptions?.filter((opt) =>
                                lead?.segment?.split(",").includes(opt?.value),
                              )
                              : []
                          }
                          onChange={(selectedOptions) => {
                            handleChange({
                              target: {
                                name: "segment",
                                value: selectedOptions,
                              },
                            });
                          }}
                          className={
                            lead?.segment && lead?.segment?.length > 0
                              ? "custom-select-valid"
                              : "custom-select-invalid"
                          }
                        />

                        {errors?.segment?.message && validated && (
                          <div className="feedback-invalid">
                            {errors?.segment?.message}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                    {/* End here Imran Khan */}
                    {/*<Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicLeadManagerId"
                        >
                          Assigned User
                        </Form.Label>
                        <Select
                          required
                          name="owner_id"
                          className={`${lead?.owner_id ? 'custom-select-valid' : 'custom-select-invalid'}`}
                          onChange={handleAssignedUserChange}
                          options={assignUsers?.map((item) => ({ value: item.id, label: item.username }))}
                          value={lead?.owner_id ? { value: lead?.owner_id || "", label: lead?.owner_name || "" } : ""}
                        />
                        {(errors?.owner_id?.message && (!lead.owner_id)) && <div className="feedback-invalid">
                          {errors?.owner_id?.message}
                        </div>}
                      </Form.Group>
                    </Col> */}

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicLeadDelegatedUsers"
                        >
                          Assign Users
                        </Form.Label>
                        <Select
                          className={`${Array.isArray(lead?.owner_ids) && lead?.owner_ids?.length > 0 ? "custom-select-valid" : "custom-select-invalid"}`}
                          isMulti
                          placeholder="Select your Assign Staff"
                          options={assignUsers?.map((item) => ({
                            value: item?.id,
                            label: item?.username,
                          }))}
                          value={lead?.owner_ids?.filter((item) => item.value)}
                          onChange={(e) => {
                            handleChange({
                              target: { name: "owner_ids", value: e },
                            });
                          }}
                        />
                        {errors?.owner_ids?.message && validated && (
                          <div className="feedback-invalid">
                            {errors?.owner_ids?.message}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </>

                  <>
                    <Col md={12} className="section-header">
                      Service Information
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicState"
                        >
                          Product
                        </Form.Label>
                        <Select
                          placeholder="Select product"
                          options={products}
                          value={
                            products?.find(
                              (p) => p?.value === lead?.product_id,
                            ) || null
                          }
                          onChange={(e) => {
                            handleChange({
                              target: { name: "product_id", value: e.value },
                            });
                            handleChange({
                              target: { name: "product_name", value: e.label },
                            });
                          }}
                        />

                        {/* <Select
                          placeholder="Select your product"
                          options={products?.map((product) => ({
                            value: product?.id,
                            label: product?.name,
                          }))}
                          onChange={(e) => {
                            handleChange({
                              target: { name: "product_id", value: e.value },
                            });
                            handleChange({
                              target: { name: "product_name", value: e.label },
                            });
                          }}
                          value={
                            lead?.product_id
                              ? {
                                value: lead?.product_id,
                                label: lead?.product_name,
                              }
                              : ""
                          }
                        ></Select> */}
                        <Form.Control.Feedback type="invalid">
                          {errors?.product_id?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* Updated by Imran Khan on 12-01-2026 as per client needs Quantity defult 1 in AMC Ticket Number */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicQuantity"
                        >
                          Quantity
                        </Form.Label>
                        <Form.Control
                          required
                          min={1}
                          type="number"
                          name="qty"
                          value={lead?.qty}
                          onChange={handleChange}
                          disabled
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.qty?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* End Here Updated by Imran Khan on 12-01-2026 as per client needs Quantity defult 1 in AMC Ticket Number */}
                    {/* <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicState"
                        >
                          Make
                        </Form.Label>

                        <Select
                          isMulti
                          placeholder="Select your makes"
                          options={accounts?.map((account) => ({
                            value: account?.id,
                            label: account?.name,
                          }))}
                          onChange={(e) => {
                            handleChange({
                              target: { name: "accounts", value: e },
                            });
                          }}
                          value={lead?.accounts?.filter((item) => item?.value)}
                        ></Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.account_id?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}

                    {/* Imran Khan Updated Make only Company Make Show in Make 06-02-2026/ */}
                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label className="form-view-label">
                          Make
                        </Form.Label>

                        <Select
                          isMulti
                          placeholder="Select your makes"
                          options={companyMakeOption}
                          value={
                            companyMakeOption?.filter((opt) =>
                              lead?.account_id?.includes(opt.value),
                            ) || []
                          }
                          onChange={(e) => {
                            handleChange({
                              target: { name: "accounts", value: e },
                            });

                            handleChange({
                              target: {
                                name: "account_id",
                                value: e?.map((x) => x.value) || [],
                              },
                            });
                          }}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.account_id?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicLeadSource"
                        >
                          Lead Enquiry Status
                        </Form.Label>
                        <Form.Select
                          placeholder="Select lead enquiry status"
                          aria-label="Select lead enquiry status"
                          name="lead_source_status"
                          value={lead?.lead_source_status || ""}
                          onChange={handleChange}
                        >
                          <option value="">---Select---</option>
                          {["HOT", "WARM", "COLD"].map((item, index) => (
                            <option value={item} key={index}>
                              {item}
                            </option>
                          ))}
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                          {errors?.leadsource?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicState"
                        >
                          Referred By
                        </Form.Label>

                        <InputGroup>
                          <Select
                            name="contact_id"
                            className="w-75"
                            // className={`${errors?.contact_id?.message ? 'border border-danger rounded' : 'border border-success rounded' }`}
                            placeholder="Select your reference name"
                            options={refContact?.map((contact) => ({
                              value: contact?.id,
                              label: contact?.contact_name,
                            }))}
                            onChange={(e) => {
                              handleChange({
                                target: { name: "contact_id", value: e.value },
                              });
                              handleChange({
                                target: {
                                  name: "contact_name",
                                  value: e?.label,
                                },
                              });
                            }}
                            value={
                              lead?.contact_id
                                ? {
                                  value: lead?.contact_id,
                                  label: lead?.contact_name,
                                }
                                : null
                            }
                          ></Select>
                          <InputGroup.Text className="d-flex justify-content-center align-items-center w-25 p-0 bg-white">
                            <Button
                              variant="link"
                              className="p-0 border-0"
                              onClick={handleContactModel}
                            >
                              <i className="fa fa-plus fa-xl text-success" />
                            </Button>
                          </InputGroup.Text>
                        </InputGroup>
                        <Form.Control.Feedback type="invalid">
                          {errors?.contact_id?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCustomerleadRemark"
                        >
                          Lead Remark
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="remark"
                          placeholder="Enter lead remark"
                          value={lead?.remark || ""}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                          pattern={regExPattern.name}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.lead_remark?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </>

                  <>
                    <Col md={12} className="section-header">
                      Customer Information
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCustomerType"
                        >
                          Customer Type
                        </Form.Label>
                        <Form.Select
                          required
                          placeholder="Select customer type"
                          aria-label="Select customer type"
                          name="customer_type"
                          value={lead?.customer_type || ""}
                          onChange={handleChange}
                        >
                          <option value="">---Select---</option>
                          <option value="Individual">Individual</option>
                          <option value="Corporate">Corporate</option>
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                          {errors?.customer_type?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {lead?.customer_type === "Corporate" && (
                      <>
                        <Col lg={6}>
                          <Form.Group>
                            <Form.Label
                              className="form-view-label"
                              htmlFor="formBasicCompanyName"
                            >
                              Company Name
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="company_name"
                              placeholder="Enter company name"
                              value={lead?.company_name || ""}
                              onChange={(e) =>
                                handleUppercaseChange(e, handleChange)
                              }
                              pattern={regExPattern.name}
                            />
                            <Form.Control.Feedback type="invalid">
                              {errors?.company_name?.message}
                            </Form.Control.Feedback>
                          </Form.Group>
                        </Col>
                      </>
                    )}

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicSector "
                        >
                          Sector
                        </Form.Label>
                        <Form.Select
                          placeholder="Select sector"
                          aria-label="Select sector"
                          name="sector"
                          value={lead?.sector || ""}
                          onChange={handleChange}
                        >
                          <option value="">---Select---</option>
                          {[
                            "Government site",
                            "Customer is private",
                            "Government customer direct with us",
                          ].map((item, index) => (
                            <option value={item} key={index}>
                              {item}
                            </option>
                          ))}
                        </Form.Select>

                        <Form.Control.Feedback type="invalid">
                          {errors?.sector?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicIsGst"
                        >
                          Is GST Applicable
                        </Form.Label>
                        <FormSelect
                          name="is_gst"
                          value={lead?.is_gst || ""}
                          onChange={handleChange}
                        >
                          <option value={""}>--select--</option>
                          <option value={"Yes"}>Yes</option>
                          <option value={"No"}>No</option>
                        </FormSelect>
                        <Form.Control.Feedback type="invalid">
                          {errors?.is_gst?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {lead?.is_gst === "Yes" && (
                      <Col lg={6}>
                        <Form.Group>
                          <Form.Label
                            className="form-view-label"
                            htmlFor="formBasicCompanyName"
                          >
                            GST Number
                          </Form.Label>
                          <Form.Control
                            type="text"
                            name="gst_no"
                            placeholder="Enter gst number"
                            value={lead?.gst_no || ""}
                            // onChange={handleChange}
                            onChange={(e) => {
                              const value = e?.target?.value;
                              setLead((prev) => ({
                                ...prev,
                                gst_no: value.replace(/\s+/g, "").toUpperCase(),
                              }));
                            }}
                            pattern={regExPattern.gstNo}
                          />
                          <Form.Control.Feedback type="invalid">
                            {errors?.gst_no?.message}
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    )}

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompetitorName "
                        >
                          Competitor Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="competitor_name"
                          placeholder="Enter competitor name "
                          value={lead?.competitor_name || ""}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                          pattern={regExPattern.name}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.competitor_name?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCustomerPrimaryName"
                        >
                          Customer Primary Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="customer_primary_name"
                          placeholder="Enter customer primary name"
                          value={lead?.customer_primary_name || ""}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                          pattern={regExPattern.name}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.customer_primary_name?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCustomerPrimaryPhone"
                        >
                          Customer Primary Phone
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="customer_primary_phone"
                          placeholder="Enter customer primary phone"
                          value={lead?.customer_primary_phone || ""}
                          onChange={handleChange}
                          maxLength={10}
                          pattern={regExPattern.phone}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.customer_primary_phone?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCustomerPrimaryName"
                        >
                          Second Person Name
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="customer_secondry_name"
                          placeholder="Enter second person name"
                          value={lead?.customer_secondry_name || ""}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                          pattern={regExPattern.name}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.customer_secondry_name?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCustomerSecondaryPhone"
                        >
                          Second Person Phone
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="customer_secondary_phone"
                          placeholder="Enter second person phone"
                          value={lead?.customer_secondary_phone || ""}
                          onChange={handleChange}
                          pattern={regExPattern.phone}
                          maxLength={10}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.customer_secondary_phone?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCustomerSecondaryDesignation"
                        >
                          Second Person Designation
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="customer_secondary_designation"
                          placeholder="Enter second person designation"
                          value={lead?.customer_secondary_designation || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.customer_secondary_designation?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </>

                  <>
                    <Col lg={12} className="section-header">
                      ADDRESS INFORMATION
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCompany"
                        >
                          Location Link
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="location_link"
                          placeholder="Enter location link"
                          value={lead?.location_link || ""}
                          onChange={(e) => handleChange(e)}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.location_link?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                          type="text"
                          name="address"
                          placeholder="Enter address"
                          value={lead?.address || ""}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicArea"
                        >
                          Area
                        </Form.Label>
                        <Form.Control
                          required
                          pattern={regExPattern.name}
                          type="text"
                          name="area"
                          placeholder="Enter area name"
                          value={lead?.area || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.area?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicState"
                        >
                          State
                        </Form.Label>

                        <Select
                          placeholder="Select your state"
                          options={states?.map((state) => ({
                            value: state,
                            label: state,
                          }))}
                          onChange={(e) => {
                            setLead((prev) => ({ ...prev, city: "" }));
                            handleChange({
                              target: { name: "state", value: e.value },
                            });
                          }}
                          value={
                            lead?.state
                              ? {
                                value: lead?.state || "",
                                label: lead?.state || "",
                              }
                              : ""
                          }
                        ></Select>
                        <Form.Control.Feedback type="invalid">
                          {errors?.state?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCity"
                        >
                          City
                        </Form.Label>
                        <Form.Control
                          required
                          pattern={regExPattern.name}
                          type="text"
                          name="city"
                          placeholder="Enter city name"
                          value={lead?.city || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.city?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    {/* <Col lg={6}>
                      <Form.Group >
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCity"
                        >
                          City
                        </Form.Label>
                        <Select
                          placeholder="Select your city"
                          // className={`${contact?.city ? 'custom-react-select-valid': 'custom-react-select-invalid' }`}
                          className={'custom-react-select'}
                          options={cities?.map((city) => ({ 'value': city, 'label': city }))}
                          onChange={(e) => {
                            handleChange({ target: { name: "city", 'value': e.value } });
                          }}
                          value={lead?.city ? { value: lead?.city || "", label: lead?.city || "" } : ""}
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.city?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}

                    <Col lg={6}>
                      <Form.Group
                        className="form-view-label"
                        htmlFor={"formBasicOfficeAddress"}
                      >
                        <Form.Label>Office Address</Form.Label>
                        <Form.Control
                          type="text"
                          name="office_address"
                          placeholder="Enter office address"
                          value={lead?.office_address || ""}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.office_address?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* Add this fields office area by shahir hussain 24-12-2025 */}
                    <Col lg={6}>
                      <Form.Group
                        className="form-view-label"
                        htmlFor={"formBasicOfficeArea"}
                      >
                        <Form.Label>Office Area</Form.Label>
                        <Form.Control
                          type="text"
                          name="office_area"
                          placeholder="Enter office area"
                          value={lead?.office_area || ""}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.office_area?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicOfficeCity"
                        >
                          Office City
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="office_city"
                          placeholder="Enter office city name"
                          value={lead?.office_city || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {errors?.office_city?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    {/* <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicStreet"
                        >
                          Complete Address
                        </Form.Label>
                        <Form.Control
                          disabled={true}
                          type="text"
                          name="address"
                          placeholder="Enter address"
                          value={lead?.address || ""}
                          onChange={handleChange}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.address?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col> */}

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicPin"
                        >
                          Pincode
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="pincode"
                          placeholder="Enter pincode"
                          value={lead?.pincode || ""}
                          onChange={handleChange}
                          pattern={regExPattern.pinCode}
                          maxLength={6}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.pincode?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>

                    <Col lg={6}>
                      <Form.Group>
                        <Form.Label
                          className="form-view-label"
                          htmlFor="formBasicCountry"
                        >
                          Country
                        </Form.Label>
                        <Form.Control
                          type="text"
                          name="country"
                          placeholder="Enter country"
                          value={lead?.country || ""}
                          // onChange={handleChange}
                          onChange={(e) =>
                            handleUppercaseChange(e, handleChange)
                          }
                          pattern={regExPattern.name}
                        />

                        <Form.Control.Feedback type="invalid">
                          {errors?.country?.message}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </>
                </Row>
              </CardBody>
            </Card>
          </Form>
        </Col>
      </Row>
      {/* Contact Modal created by shahir hussain 11-12-2025 AMC Ticket Number 1002 */}
      <Modal
        show={showContactModel}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <Modal.Title id="contained-modal-title-vcenter">
            Create Contact (Referral By)
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Container className="view-form">
            <Row>
              <Col lg={12}>
                <Form
                  className="mt-3"
                  onSubmit={handleSubmitContact}
                  controlId="taskEdit"
                >
                  <Row>
                    <Col>
                      <Form.Group className="mx-3" controlId="formBasicTitle">
                        <Form.Label
                          className="form-view-label"
                          controlId="formBasicTitle"
                        >
                          First Name
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          name="firstname"
                          placeholder="Enter First Name"
                          onChange={handleChangeContactPartner}
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mx-3" controlId="formBasicTitle">
                        <Form.Label
                          className="form-view-label"
                          controlId="formBasicTitle"
                        >
                          Last Name
                        </Form.Label>
                        <Form.Control
                          required
                          type="text"
                          name="lastname"
                          placeholder="Enter Last Name"
                          onChange={handleChangeContactPartner}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <Form.Group className="mx-3" controlId="formBasicTitle">
                        <Form.Label
                          className="form-view-label"
                          controlId="formBasicTitle"
                        >
                          Mobile
                        </Form.Label>
                        <Form.Control
                          style={{ height: "36px" }}
                          required
                          type="phone"
                          minLength="10"
                          maxLength="10"
                          name="phone"
                          placeholder="Enter Mobile Number"
                          onKeyDownCapture={(e) => {
                            (e?.key == " " ||
                              (e.key.length == 1 && isNaN(e.key))) &&
                              e.preventDefault();
                          }}
                          onChange={handleChangeContactPartner}
                        />
                      </Form.Group>
                    </Col>
                    <Col>
                      <Form.Group className="mx-3" controlId="formBasicTitle">
                        <Form.Label
                          className="form-view-label"
                          controlId="formBasicTitle"
                        >
                          Email
                        </Form.Label>
                        <Form.Control
                          style={{ height: "36px" }}
                          type="email"
                          name="email"
                          placeholder="Enter Email"
                          onChange={handleChangeContactPartner}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="success" onClick={handleSubmitContact}>
            Save
          </Button>
          <Button onClick={handleContactModelClose} variant="light">
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default LeadEdit;
